<app-spinner></app-spinner>
@if ((authService.isAuthenticated$ | async) || false) {
  <div class="container-size">
    @if (isAuthorized) {
      <app-header></app-header>
    }

    <div class="flex-grow-1">
      <router-outlet></router-outlet>
    </div>

    @if (isAuthorized) {
      <app-footer></app-footer>
    }
  </div>
}
